import Crud from '../views/Cid/Crud'
import Entity from '../views/Cid/Add'

let routes = {
    path: '/cids',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cids/add',
            name: 'NewCid',
            component: Entity,
            meta: {
                pageTitle: 'cid.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'cid.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cids/edit/:id?',
            name: 'EditCid',
            component: Entity,
            meta: {
                pageTitle: 'cid.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'cid.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cids',
            name: 'list-cids',
            component: Crud,
            meta: {
                pageTitle: 'cid.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'cid.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
